/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { updateProfile } from '../../config/updateProfile.config';

import axios from 'axios';
import { Graphql } from '@common/graphql';
import { CREATE_MY_PROFILE } from '../../api/graphql';
import { vappContainer } from '@/application';
import { apiConfig } from '@/config/apiConfig';
import { AppNavigatorService } from '@/AppNavigator';
import { StorageModule } from '@vlinder-web/storage-module-react';
import toast from 'react-hot-toast';
import { getErrorMessage } from '@/utils/error.message';
import { error } from 'console';

export interface ICreateProfileMethods extends IPluginMethodMap {
  createProfile(args: any): Promise<any>;
}

const loginSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export class CreateProfileService implements IAgentPlugin {
  readonly methods: ICreateProfileMethods;

  constructor() {
    this.methods = {
      createProfile: this.createProfile.bind(this),
    };
  }

  async createProfile(args: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    // const token = getToken();
    const token = loginSrv()?.getToken();
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();

    console.log('data in query', args);
    const storageService = StorageModule.getInstance();
    const _localData = storageService.get('userProfile', 'local');
    const _sessionData = storageService.get('userProfile', 'session');
    const userData = _sessionData ?? _localData;
    try {
      if (client) {
        console.log(client);
        const res = await client
          .mutation(
            CREATE_MY_PROFILE,

            { input: { ...args } }
          )
          .toPromise();

        if (res?.data?.setUpOrgProfile) {
          return {
            data: res?.data?.setUpOrgProfile,
          };
        }
        console.log("companysetperror-->inservice",res)
        getErrorMessage(res?.error)
        throw res?.error?.graphQLErrors?.[0];
      }
    } catch (err: any) {
      // getErrorMessage(err)
      throw err;
    }
  }
}
